export enum FaseAssistenteEnum {
  Arquivo = 0,
  Validacao = 1,
  Natureza = 2,
  Regras = 3,
}
